/**
 * Whitelist встраиваемого видео — зеркало утилиты админки
 * (`Modules/Content/utils/embed.ts` в `skuby/apps`, ADR-0002).
 *
 * Нода `embed` хранит провайдера и идентификатор ролика, а не готовый URL:
 * адрес плеера собирается здесь по закрытому списку, поэтому произвольный
 * `src` не попадёт в `<iframe>` витрины даже если в `bodyJson` окажется
 * что-то постороннее. Тело контента санитайзер не проходит (HTML в системе
 * не хранится), эта проверка — единственный барьер.
 *
 * Новый провайдер добавляется в двух репозиториях: здесь и в админке.
 */

export type EmbedProvider = 'youtube' | 'vk'

export const EMBED_PROVIDER_LABELS: Record<EmbedProvider, string> = {
  youtube: 'YouTube',
  vk: 'VK Видео',
}

/** Идентификаторы роликов — только безопасный алфавит (подставляем в src как есть). */
const YOUTUBE_ID = /^[\w-]{6,20}$/
const VK_ID = /^-?\d+_\d+$/

/** Адрес плеера по атрибутам ноды; неизвестный провайдер/битый id — null. */
export function embedSrc(attrs: {
  provider?: unknown
  videoId?: unknown
}): string | null {
  const provider = String(attrs.provider ?? '')
  const videoId = String(attrs.videoId ?? '')

  if (provider === 'youtube' && YOUTUBE_ID.test(videoId)) {
    return `https://www.youtube.com/embed/${videoId}`
  }
  if (provider === 'vk' && VK_ID.test(videoId)) {
    const [oid, id] = videoId.split('_')
    return `https://vk.com/video_ext.php?oid=${oid}&id=${id}`
  }

  return null
}

/** Подпись плеера для `title` iframe (доступность). */
export function embedTitle(provider: unknown): string {
  return EMBED_PROVIDER_LABELS[provider as EmbedProvider] ?? 'Видео'
}
